import { Component, OnInit } from '@angular/core';
import { isNullOrUndefined } from 'util';
import { isNull } from '@angular/compiler/src/output/output_ast';
import { Observable } from 'rxjs';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { DataSharingService } from '../../../../auth/data-sharing.service';
import { EnlistmentService } from 'src/app/services/enlistment/enlistment.service';
//import { Prevendor } from 'src/app/model/prevendor.model';

import { NgForm } from '@angular/forms';
import { ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpErrorResponse } from '@angular/common/http';
import { distinctUntilChanged } from 'rxjs/operators';
import { Binary } from '@angular/compiler';
import { ReplaySubject } from 'rxjs';
import { TenderingService } from 'src/app/services/tendering/tendering.service';

@Component({
  selector: 'app-enqlistadmin',
  templateUrl: './enqlistadmin.component.html',
  styleUrls: ['./enqlistadmin.component.css']
})
export class EnqlistadminComponent implements OnInit {

  // selectedSmgId: any = [];
  // selectedSmgIdString: string = "";
  // showSmgMaster: boolean = false;
  // showEnlistmentForm: boolean = false;
  // completedRegister: boolean = false;

  data: any;
  //preVendor: Prevendor;

  

  constructor(private tenderingServices: TenderingService, private router : Router,
    private route: ActivatedRoute) {
      
     }

  ngOnInit() {
    //this.showSmgMaster = true;
    this.getEnquiryList();
    //this.preVendor = new Prevendor();
    
  }

  getEnquiryList() {
    this.tenderingServices.GetEnquiryList().subscribe(
      data => {
        this.data = data;
        console.log(this.data);
      }
    )
  }

  // sendQuote()
  // {
  //   alert("clicked");
  //   //this.router.navigate(['/dashboard']);
  //   //this.router.navigate(['/dashboard'], { relativeTo: this.route })
  // }

  sendTechQuote= function (id) {
    //alert(id);
    this.router.navigate(['/sendtechquote/' + id + '']);
  }
  sendPriceQuote= function (id) {
    this.router.navigate(['/sendpricequote/' + id + '']);
  }
  sendBoth = function (id) {
    //alert(id);
    this.router.navigate(['/sendpriceandtechquote/' + id + '']);
  }

  // submitSmgId() {
  //   // console.log(this.selectedSmgId);
  //   this.showSmgMaster = false;
  //   this.showEnlistmentForm = true;
  //   this.completedRegister = false;

  //   for (var i = 0; i < this.selectedSmgId.length; i++) {
  //     this.selectedSmgIdString = this.selectedSmgIdString + this.selectedSmgId[i];
  //     if (i < this.selectedSmgId.length - 1) {
  //       this.selectedSmgIdString = this.selectedSmgIdString + ",";
  //     }
  //   }

  //   //alert(this.selectedSmgIdString);
  // }
  searchEnqList(keyword)
  {
    this.tenderingServices.searchEnquiry(keyword).subscribe(
      (data) => {
        this.data = data;
        console.log(data);
      }
    );
  }

  
}
